import React from 'react';
import { Button, Form, Input } from 'antd';
import { func } from 'prop-types';
import { initialFilters } from '../../utils/utils';

const Filter = ({ onChange }) => {
	const [form] = Form.useForm();

	return (
		<div>
			<Form
				form={form}
				initialValues={initialFilters}
				onFinish={onChange}
				style={{ display: 'flex' }}
			>
			<Form.Item
					label="Nombre"
					name="fullName"
					style={{ flex: 2, marginRight: '10px' }}
				>
					<Input placeholder="Nombre y Apellido" allowClear />
				</Form.Item>
				<Form.Item
					label="Email"
					name="email"
					style={{ flex: 2, marginRight: '10px' }}
					rules={[
						{
							type: 'email'
						}
					]}
				>
					<Input placeholder="Email" allowClear />
				</Form.Item>
				<Form.Item
					name={['internalIdentifier']}
					label="Cod. interno"
					style={{ flex: 2, marginRight: '10px' }}
					dependencies={['internalIdentifier']}
					rules={[
						() => ({
							validator(_, value) {
								if (!value) {
									return Promise.resolve();
								}
								return Promise.resolve();


							},
						})
					]}
				>
					<Input placeholder="Código  Interno" allowClear />
				</Form.Item>


				<Form.Item>
					<Button type="primary" htmlType="submit" loading={false} style={{ marginRight: '10px' }}>
						Buscar
					</Button>
					<Button
						type="link"
						htmlType="submit"
						loading={false}
						onClick={() => form.resetFields()}
					>
						Limpiar
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};

Filter.propTypes = {
	onChange: func.isRequired,
};



export default Filter;
